<template>
  <div>
    <ContentLoader
      :height="41"
      :width="320"
      :speed="1"
      primary-color="#f3f3f3"
      secondary-color="#ecebeb"
      class="qr-code-loader-mobile"
    >
      <rect x="0" y="2" rx="4" ry="4" width="300" height="15" />
      <rect x="0" y="24" rx="4" ry="4" width="220" height="15" />
    </ContentLoader>

    <ContentLoader
      :height="22"
      :width="600"
      :speed="1"
      primary-color="#f3f3f3"
      secondary-color="#ecebeb"
      class="qr-code-loader-desk"
    >
      <rect x="0" y="0" rx="4" ry="4" width="500" height="18" />
    </ContentLoader>
  </div>
</template>

<style lang="scss" scoped>

.qr-code-loader-desk {
  display: none;

  @media (min-width: $screen-sm-min) {
    display: block;
    max-width: 600px;
  }
}

.qr-code-loader-mobile {
  max-width: 320px;

  @media (min-width: $screen-sm-min) {
    display: none;
  }
}
</style>

<script>
import { ContentLoader } from 'vue-content-loader';

export default {
  components: {
    ContentLoader,
  },
};
</script>
